import script from "./DigitalCertificatesView.vue?vue&type=script&setup=true&lang=js"
export * from "./DigitalCertificatesView.vue?vue&type=script&setup=true&lang=js"

import "./DigitalCertificatesView.vue?vue&type=style&index=0&id=242375d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-242375d6"]])

export default __exports__